import React from 'react';
import { useTranslation } from 'react-i18next';
import { ContentContainer } from '../../../components/Filters/components/ContentContainer';
import { RadioList } from '../../../components/Filters/components/RadioList';
import { useSearchContext } from '../contexts';

type BotFilterValue = string; // 'include'= null | 'exclude'= false | 'showOnly'= true

interface BotOption {
  value: BotFilterValue;
  name: string;
  disabled?: boolean;
  tooltipText?: string;
}

interface BotsChooserProps {
  disableShowOnly?: boolean;
  disabledTooltip?: string;
}

export const BotsChooser: React.FC<BotsChooserProps> = ({ disableShowOnly = false, disabledTooltip }) => {
  const { t } = useTranslation();
  const { state, updateDraftFilters } = useSearchContext();

  const options: BotOption[] = [
    { value: 'include', name: t('Include inauthentic actors'), disabled: false },
    { value: 'exclude', name: t('Exclude inauthentic actors'), disabled: false },
    { value: 'showOnly', name: t('Show only inauthentic actors'), disabled: disableShowOnly, tooltipText: disableShowOnly ? disabledTooltip : undefined }
  ];

  const mapBotsValueToFilterValue = (value: BotFilterValue): { value: null | boolean; exclude: boolean } => {
    switch (value) {
      case 'include':
        return {value: null, exclude: false};
      case 'exclude':
        return {value: true, exclude: true};
      case 'showOnly':
        return {value: true, exclude: false};
      default:
        return {value: null, exclude: false};
    }
  };

  const mapFilterValueToBotsValue = (value: null | boolean, exclude: boolean): BotFilterValue => {
    if (value === null && exclude === false) return 'include';
    if (value === true && exclude === true) return 'exclude';
    if (value === true && exclude === false) return 'showOnly';
    return 'include';
  };

  const currentBotsValue = mapFilterValueToBotsValue(state.draftFilters.bots.value, state.draftFilters.bots.exclude);
  const selectedOption = options.find(option => option.value === currentBotsValue) || options[0];

  return (
    <ContentContainer>
      <RadioList
        items={options}
        name="bots-chooser"
        selectedValue={selectedOption.value}
        onChange={(value: string) => {
          // Prevent selecting "Show only" if it's disabled
          if (value === 'showOnly' && disableShowOnly) {
            return;
          }
          const filterValue = mapBotsValueToFilterValue(value as BotFilterValue);
          updateDraftFilters({
            bots: {
              value: filterValue.value,
              exclude: filterValue.exclude
            }
          });
        }}
      />
    </ContentContainer>
  );
};
      